import { LoadingInfo, LoadingIcon } from "./styled";

export const Loading = () => (
  <>
    <LoadingInfo>Please wait, projects are being loaded...</LoadingInfo>
    <LoadingIcon />
  </>
);
